export enum ScolariteType {
  college = "college",
  enseignement_superieur = "enseignement_superieur",
  grande_ecole_du_numerique = "grande_ecole_du_numerique",
  inconnue = "inconnue",
  lycee = "lycee",
}

export enum EtudiantType {
  cap_1 = "cap_1",
  cap_2 = "cap_2",
  seconde = "seconde",
  premiere = "premiere",
  terminale = "terminale",
  bts_1 = "bts_1",
  but_1 = "but_1",
  cpge_1 = "cpge_1",
  licence_1 = "licence_1",
  licence_2 = "licence_2",
  licence_3 = "licence_3",
  master_1 = "master_1",
  master_2 = "master_2",
  doctorat_1 = "doctorat_1",
  doctorat_2 = "doctorat_2",
  doctorat_3 = "doctorat_3",
  autre = "autre",
}

export enum MentionBaccalaureatType {
  mention_assez_bien = "mention_assez_bien",
  mention_bien = "mention_bien",
  mention_tres_bien = "mention_tres_bien",
  mention_tres_bien_felicitations_jury = "mention_tres_bien_felicitations_jury",
  non_renseignee = "non_renseignee",
}

export enum GroupeSpecialiteType {
  groupe_330 = "groupe_330",
  groupe_230 = "groupe_230",
  aucun = "aucun",
}
